import React from 'react';
import Layout from 'components/layouts';
import Title from 'components/typografy/title';
import Text from 'components/typografy/text';
import styles from './styles.module.scss';
import { Link } from 'react-router-dom';
import { APP_PATHS } from '../../constants';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { ReactComponent as BankNoteIcon } from 'svg/bank-note.svg';
import List from './withdrawals-list';
import { useQuery } from 'react-query';
import { activityStats } from 'api/user';
import { QUERY_KEYS } from '../../constants'; // API cache keys
import { Capacitor } from '@capacitor/core';
import { ActivityStatsResponse } from 'types/user'; 

const Cashout: React.FC<any> = () => {
  
  // Check if running on native platform (e.g., mobile app)
  const isNative = Capacitor.isNativePlatform();

  // Use React Query to fetch user activity stats (managed by the header component)
  const { data: stats } = useQuery<ActivityStatsResponse>(
    [QUERY_KEYS.USER.ACTIVITY_STATS],
    activityStats,
    {
      enabled: false, // Only reads from cache, disable automatic refetching, rely on header component to manage refetching
    }
  );

  return (
    <Layout hideFooter={isNative}>
      {/* Hide footer if runs on native app */}
      {/* Top section with title, description, balance and button */}
      <div className={styles.top}>
        <div className={styles.topLeft}>
          {/* Section title */}
          <Title variant="h1">Cashout</Title>

          {/* Description text */}
          <Text variant="large">
            Withdraw your rewards and prizes through PayPal, Visa, Amazon, Google Play, and more (availability may vary by country).
          </Text>

          {/* Balance card ABOVE button */}
          <div className={styles.balanceCard}>
            <BankNoteIcon />
            <div>
              <Text variant="medium">Current Balance</Text>
              <Title variant="h1">${Number(stats?.balance ?? 0).toFixed(2)}</Title>
            </div>
          </div>

          {/* Withdrawal button */}
          <Link
            to={APP_PATHS.PROFILE}
            state={{ activeTab: '2' }}
            className={styles.whiteButton}
          >
            Withdrawals History <HiOutlineArrowNarrowRight />
          </Link>
        </div>
      </div>

      {/* List of all withdrawal vendor options elements */}
      <div className={styles.content}>
        <List />
      </div>
    </Layout>
  );
};

export default Cashout;
